import { createSlice } from "@reduxjs/toolkit";
import stringUtils from "../../../../_services/string-utils";
import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { integrationReducerActions } from "../../../_commons/integration.reducer";

export const ZALANDO_ENVIRONMENT = {
    PRODUCTION: "PRODUCTION",
    SANDBOX: "SANDBOX",
};

export const initialNewConfiguration = {
    clientUUID: "",
    shopName: "",
    clientId: "",
    clientSecret: "",
    merchantId: "",
    environment: ZALANDO_ENVIRONMENT.PRODUCTION,
    useExistingSettingsClientUUID: null,
    useExistingSettings: false,
    autoSetup: true,
};

export const initialDeleteConfigurationRequest = {
    externalUUID: "",
    clientUUID: "",
    deleteConnectedAuthData: false,
};

export const initialTestConnectionResult = {
    success: null,
    merchantId: null,
    merchantName: null,
    environment: null,
    errorMessage: null,
};

export const initialZalandoReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: { ...initialNewConfiguration },
    deleteConfigurationRequest: { ...initialDeleteConfigurationRequest },
    testConnectionResult: { ...initialTestConnectionResult },
    isTestConnectionLoading: false,
    testConnectionErrorMessage: null,
    isConnectLoading: false,
    connectErrorMessage: null,
    isDisconnectLoading: false,
    disconnectErrorMessage: null,
    importData: null,
};

const zalandoSlice = createSlice({
    name: "zalando",
    initialState: initialZalandoReducer,
    reducers: {
        ...integrationReducerActions,
        setDeleteConfigurationRequest(state, action) {
            state.deleteConfigurationRequest = action.payload;
        },
        deleteConfigurationRequest(state) {
            state.isDeleteLoading = true;
            state.deleteErrorMessage = null;
            state.successMessage = null;
        },
        deleteConfigurationSuccess(state, action) {
            state.configurations = [...state.configurations].filter(
                (configuration) => !stringUtils.equals(configuration.externalUUID, action.payload.externalUUID)
            );
            state.configurationToBeDeleted = null;
            state.deleteConfigurationModal = false;
            state.isDeleteLoading = false;
            state.successMessage = "Integration gelöscht";
        },
        deleteConfigurationFailure(state, action) {
            state.isDeleteLoading = false;
            state.deleteErrorMessage = action.payload;
        },

        resetEditConfigurationToConfiguration(state) {
            state.editConfiguration = state.configuration;
        },

        testConnectionRequest(state) {
            state.isTestConnectionLoading = true;
            state.testConnectionErrorMessage = null;
            state.testConnectionResult = { ...initialTestConnectionResult };
        },
        testConnectionSuccess(state, action) {
            state.isTestConnectionLoading = false;
            state.testConnectionResult = action.payload;
        },
        testConnectionFailure(state, action) {
            state.isTestConnectionLoading = false;
            state.testConnectionErrorMessage = action.payload;
            state.testConnectionResult = { ...initialTestConnectionResult };
        },
        resetTestConnectionResult(state) {
            state.testConnectionResult = { ...initialTestConnectionResult };
            state.testConnectionErrorMessage = null;
        },

        connectRequest(state) {
            state.isConnectLoading = true;
            state.connectErrorMessage = null;
            state.successMessage = null;
        },
        connectSuccess(state, action) {
            state.isConnectLoading = false;
            state.configuration = action.payload;
            state.editConfiguration = action.payload;
            state.successMessage = "Zalando-Integration verbunden";
        },
        connectFailure(state, action) {
            state.isConnectLoading = false;
            state.connectErrorMessage = action.payload;
        },

        disconnectRequest(state) {
            state.isDisconnectLoading = true;
            state.disconnectErrorMessage = null;
        },
        disconnectSuccess(state) {
            state.isDisconnectLoading = false;
            state.configuration = null;
            state.editConfiguration = null;
            state.successMessage = "Zalando-Integration getrennt";
        },
        disconnectFailure(state, action) {
            state.isDisconnectLoading = false;
            state.disconnectErrorMessage = action.payload;
        },

        startPreImportRequest(state) {
            state.importData = null;
            state.isImportLoading = true;
            state.importErrorMessage = null;
            state.importSuccessMessage = null;
            state.updateErrorMessage = null;
        },
        startPreImportSuccess(state, action) {
            state.importData = action.payload;
            state.isImportLoading = false;
        },
        startPreImportFailure(state, action) {
            state.importData = null;
            state.isImportLoading = false;
            state.importErrorMessage = action.payload;
        },

        startFullImportRequest(state) {
            state.isImportLoading = true;
            state.importData = null;
            state.importSuccessMessage = null;
            state.importErrorMessage = null;
        },
        startFullImportSuccess(state) {
            state.isImportLoading = false;
            state.importSuccessMessage = "Import geplant. Sie erhalten eine E-Mail, sobald er abgeschlossen ist.";
        },
        startFullImportFailure(state, action) {
            state.isImportLoading = false;
            state.importErrorMessage = action.payload;
        },

        setSubmitted(state, action) {
            state.submitted = action.payload;
        },

        resetSuccessMessages(state) {
            state.successMessage = null;
        },
        resetUpdateErrorMessage(state) {
            state.updateErrorMessage = null;
        },
    },
});

export default zalandoSlice;
